<nav class="sidebar navbar-dark bg-dark d-flex flex-column">
    <div class="sidebar-header" *ngIf="header">
        <ng-container *ngTemplateOutlet="header"></ng-container>
    </div>

    <ul class="nav flex-column navbar-nav" *ngIf="showNavigation">
        <li *ngIf="showOverview" routerLinkActive="active">
            <a class="nav-link" routerLink="../overview">Overview</a>
        </li>
        <li *ngIf="showEdit" routerLinkActive="active">
            <a class="nav-link" routerLink="../edit">Edit</a>
        </li>
        <li *ngIf="showTerminalStatement" [ngClass]="{'active': isTerminalStatement}">
            <a class="nav-link" routerLink="../terminalStatement">Kajmand / Terminal</a>
        </li>
        <li *ngIf="showTimeline" routerLinkActive="active">
            <a class="nav-link" routerLink="../timeline">Timeline</a>
        </li>
        <li *ngIf="showComponents" routerLinkActive="active">
            <a class="nav-link" routerLink="../components">Components</a>
        </li>
        <li *ngIf="showGangs" routerLinkActive="active">
            <a class="nav-link" routerLink="../gangs">Gangs</a>
        </li>
        <li *ngIf="showReports" routerLinkActive="active">
            <a class="nav-link" routerLink="../reports">Reports</a>
        </li>
        <li *ngIf="showFiles" routerLinkActive="active">
            <a class="nav-link" routerLink="../files">Files</a>
        </li>
        <li *ngIf="showMail" routerLinkActive="active">
            <a class="nav-link" routerLink="../mail">Mail Recipients</a>
        </li>
        <li *ngIf="showMail" routerLinkActive="active">
            <a class="nav-link" routerLink="../maillog">Mail Log</a>
        </li>
        <li *ngIf="showLinks" routerLinkActive="active">
            <a class="nav-link" routerLink="../links">Link to project</a>
        </li>
        <li *ngIf="showFiles" routerLinkActive="active">
            <a class="nav-link" routerLink="../projectDocuments">Project Documents</a>
        </li>
        <li *ngIf="showReportAndStatistics" routerLinkActive="active">
            <a class="nav-link" routerLink="../projectreport">Project Report / Statistics</a>
        </li>
    </ul>

    <ng-content></ng-content>

    <div class="p-3 text-light small mt-auto" *ngIf="customer?.customer; else noCustomer">
        <strong>Customer:</strong><br>
        <span>{{ customer.customer.name }}</span><br>
        <span>{{ customer.customer.postalCode }} {{ customer.customer.city }}, {{ customer.customer.country }}</span><br>
        <span>{{ customer.customer.address }}</span>
    </div>

    <ng-template #noCustomer>

    </ng-template>

</nav>
